import { WORK_LOCATION } from './worklog';

export const REJECTED = 'REJECTED';
export const APPROVED = 'APPROVED';
export const PENDING = 'PENDING';
export const SUBMITTED = 'SUBMITTED';
export const CANCELLED = 'CANCELLED';
export const REQUESTED = 'REQUESTED';

export const WORKLOG_STATUS = {
  PENDING: PENDING,
  REJECTED: REJECTED,
  APPROVED: APPROVED,
  SUBMITTED: SUBMITTED,
  CANCELLED: CANCELLED,
};

export const ATTENDANCE_LOCATION_LABEL = {
  [WORK_LOCATION.OFFICE]: { present: 'Working from office', past: 'Worked from office' },
  [WORK_LOCATION.HOME]: { present: 'Working remotely', past: 'Worked remotely' },
};

export const ATTENDANCE_SUMMARY_FIELDS = {
  WORKLOG: 'worklog',
  LEAVE: 'leave',
  MISSING: 'missing',
};

export const attendanceIconMapper = {
  WIFI_CONNECTED: 'bg-tertiary-green-45',
  WIFI_NOT_CONNECTED: 'bg-tertiary-red-10',
  PENDING: 'bg-tertiary-orange-10',
  LEAVE: 'bg-tertiary-purple-10',
};

export const attendanceBadgeColorMapper = {
  LEAVE: '#f7e9ff',
  NO_WORKLOG: '#fbf2d3',
  OFFICE_NOT_CHECKED_IN: '#c52e23',
  PRESENT: '#5dc17c',
};
